<template>
  <div class="row">
    <div class="col-md-12">
      <textarea
        class="form-control"
        placeholder="Note Description"
        v-model="noteData.description"
        rows="5"
      ></textarea>
      <div class="text-danger" v-if="errors.note_description">
        {{ errors.note_description[0] }}
      </div>
    </div>
    <div class="col-md-12 mt-3">
      <div class="d-flex justify-content-end">
        <button class="btn btn-success" @click="saveNote">
          <span v-if="!isLoading">Save Note</span>
          <span v-else>Loading...</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";

export default {
  props: {
    leadId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,

      noteData: {
        description: "",
      },

      errors: {},
    };
  },
  mounted() {
    const fullPath = this.$route.fullPath;
    const lastPart = fullPath.split("/").filter(Boolean).pop();
    this.currentPath = lastPart;
  },
  methods: {
    async saveNote() {
      this.isLoading = true;
      const endpoint = "/store-leads-details-note-info";
      const method = "post";
      let body = {
        lead_id: this.leadId,
        note_description: this.noteData.description,
        key_account: this.currentPath == 'key-account-details' ? 'Y':'N'
      };
      try {
        const response = await http[method](endpoint, body);
        this.$emitter.emit("form-submitted");
        this.$toast.success(response.data.message);
        this.errors = {};
        this.isLoading = false;
        this.noteData = {
          description: "",
        };
      } catch (error) {
        this.isLoading = false;
        this.errors = error.response.data.errors;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
